import React, { Component } from "react";
import { bindActionCreators } from "redux";

import connect from "react-redux/es/connect/connect";
import { trimFormData } from "../../../../utils/common";
import * as validator from "../../../../utils/validator";
import queryString from "query-string";
import { setUnblock } from "../../../../navigation/navigationBlocker";
import { history } from "../../../../store/configure/configureStore";
import {
  BANNER_MANAGEMENT,
  ADD_BANNER,
  EDIT_BANNER,
} from "../../../../navigation/routes";

import BannerManagementView from "./BannerManagementView";

import {
  getBannerList,
  setRowReordered,
  setRowReorderWarningModal,
  setBannerScreenFilter,
  resetBannerScreenFilter,
  deleteBanner,
} from "../../../../store/BannerManagement/BannerManagementActions";
import {
  getStatusList,
  getBannerScreenList,
} from "../../../../store/master/masterActions";

class BannerManagementContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        searchValue: {
          titleSearch: "",
          statusSearch: "",
          bannerScreenFilterValue: this.props.bannerScreenFilter,
        },
      },
      showMenuOptions: { menu: false },
      showModal: {
        showWarningModal: false,
        showDeleteModal: false,
      },
    };

    //
    this.handleShowMenuOptions = this.handleShowMenuOptions.bind(this);
    this.handleCloseMenuOptions = this.handleCloseMenuOptions.bind(this);
    //
    this.onChangeSearchInput = this.onChangeSearchInput.bind(this);
    this.onClickSearch = this.onClickSearch.bind(this);
    this.onChangeBannerScreenOption =
      this.onChangeBannerScreenOption.bind(this);
    //
    this.onClickStatusDropDownFilterOptions =
      this.onClickStatusDropDownFilterOptions.bind(this);
    //
    this.handleSaveDragAndDropRows = this.handleSaveDragAndDropRows.bind(this);
  }

  componentDidUpdate(prevProps) {
    // console.log("prevProps", prevProps);
    if (prevProps.showRowReorderedModal !== this.props.showRowReorderedModal) {
      this.setState({
        showModal: {
          showWarningModal: this.props.showRowReorderedModal,
        },
      });
    }

    //-------------------set banner screen
    if (prevProps.bannerScreenFilter !== this.props.bannerScreenFilter) {
      this.setState(
        (prev) => ({
          ...prev,
          fields: {
            searchValue: {
              ...prev.fields?.searchValue,
              bannerScreenFilterValue: this.props.bannerScreenFilter, //set redux state value
            },
          },
        }),
        () => this.onClickSearch() //filter screens
      );
    }

    //-------------------Block navigation to other pages

    // Check if rowReordered state has changed
    if (prevProps.rowReordered !== this.props.rowReordered) {
      // Update the block based on the new value of rowReordered
      if (this.unblock) {
        this.unblock(); // Unblock the previous blocker
      }
      console.log("update  as");
      // Re-apply the block logic with the updated rowReordered value
      this.unblock = history.block((location, action) => {
        const { rowReordered } = this.props; // Get the updated value of rowReordered
        const internalPaths =
          location?.pathname?.includes(ADD_BANNER) ||
          location?.pathname?.includes(BANNER_MANAGEMENT) ||
          location?.pathname?.includes(EDIT_BANNER);

        if (!internalPaths && rowReordered) {
          console.log("update working as");

          this.props.setRowReorderWarningModal(true, location?.pathname);
          return false; // Block navigation
        }
      });
    }

    //unblock navigation if rowReOrdered is false
    if (this.props.rowReordered === false) {
      if (this.unblock) {
        this.unblock(); // Unblock the blocker
      }
    }
  }

  componentDidMount() {
    //on refreshing page reset the redux state of row reorder
    if (window.location.pathname === "/media/banner-management") {
      this.props.setRowReordered(false);
    }

    this.props.getStatusList();
    this.props.getBannerScreenList();
    if (this.props.bannerScreenFilter === "") {
      //if redux state is empty then only call this function
      this.props.getBannerList();
    } else {
      this.onClickSearch();
    }

    //
    // Block navigation when row are reordered,
    this.unblock = history.block((location, action) => {
      console.log("location", location);
      const { rowReordered } = this.props;
      // const shouldBlock = rowReordered;
      const internalPaths =
        location?.pathname?.includes(ADD_BANNER) ||
        location?.pathname?.includes(BANNER_MANAGEMENT) ||
        location?.pathname?.includes(EDIT_BANNER);
      if (!internalPaths) {
        // Prevent navigation
        return false; // Prevent the default popup behavior
      }
    });
  }

  componentWillUnmount() {
    // window.removeEventListener(
    //   "beforeunload",
    //   this.props.setRowReordered(false)
    // );

    // clear the banner screen filter except these paths
    const persistTheFiler =
      window?.location?.pathname?.includes(ADD_BANNER) ||
      window?.location?.pathname?.includes(BANNER_MANAGEMENT) ||
      window?.location?.pathname?.includes(EDIT_BANNER);

    if (!persistTheFiler) {
      this.unblock(); //unblock navigation
      this.props.resetBannerScreenFilter();
    }
  }

  //--------------------------hanlde filter menu
  handleShowMenuOptions = () => {
    this.setState((prevState) => ({
      showMenuOptions: { menu: true },
    }));
  };

  handleCloseMenuOptions = () => {
    this.setState((prevState) => ({
      showMenuOptions: { menu: false },
    }));
  };

  showWarningPopup = () => {
    this.setState((prevState) => ({
      showModal: { ...prevState.showModal, showWarningModal: true },
    }));
  };

  showDeletePopup = () => {
    this.setState((prevState) => ({
      showModal: { ...prevState.showModal, showDeleteModal: true },
    }));
  };

  onCloseModal = () => {
    this.setState(
      (prevState) => ({
        showModal: {
          showWarningModal: false,
          showDeleteModal: false,
        },
      }),
      () => {
        // this.props.setRowReordered(false);
        this.props.setRowReorderWarningModal(false);
        // if (this.props?.redirectLink === "/media/add-banner") {
        //   history.push("/media/add-banner");
        // } else {
        //   history.push(this.props.redirectLink);
        // }
      }
    );
  };

  //--------------------------Search Banner
  onChangeSearchInput = (e) => {
    const { value } = e.target;
    this.setState(
      (prev) => ({
        ...prev,
        fields: {
          searchValue: { ...prev.fields.searchValue, titleSearch: value },
        },
      }),
      () => {
        if (this.state?.fields?.searchValue?.titleSearch === "") {
          const { titleSearch, bannerScreenFilterValue, statusSearch } =
            this.state?.fields?.searchValue;
          const data = {
            bannerTitle: titleSearch,
            screenName: bannerScreenFilterValue?.label,
            statusName: statusSearch,
          };

          this.props.getBannerList(data);
        }
      }
    );
  };

  onClickSearch = () => {
    const { titleSearch, bannerScreenFilterValue, statusSearch } =
      this.state?.fields?.searchValue;

    const data = {
      bannerTitle: titleSearch,
      screenName: bannerScreenFilterValue?.label,
      statusName: statusSearch,
    };

    this.props.getBannerList(data);
  };

  //--------------------------filter Banner using dropdown
  onChangeBannerScreenOption = (val) => {
    // console.log(val);
    this.setState(
      (prev) => ({
        ...prev,
        fields: {
          ...prev.fields,
          searchValue: {
            ...prev.fields.searchValue,
            bannerScreenFilterValue: val,
          },
        },
      }),
      () => {
        // this.onClickSearch();
        this.props.setBannerScreenFilter(val); //set redux state
      }
    );
  };

  //--------------------------filter based on status
  onClickStatusDropDownFilterOptions = (value) => {
    this.setState(
      (prev) => ({
        ...prev,
        fields: {
          ...prev.fields,
          searchValue: {
            ...prev.fields.searchValue,
            statusSearch: value?.status,
          },
        },
      }),
      () => this.onClickSearch()
    );
  };

  //--------------------------filter based on status
  handleSaveDragAndDropRows = (dataArray) => {
    const dataSet = dataArray?.map((row, index) => ({
      bannerId: row?._id,
      position: index + 1,
      // position: row?.position,
    }));
    const { titleSearch, bannerScreenFilterValue, statusSearch } =
      this.state?.fields?.searchValue;
    const data = {
      bannerIds: dataSet,
      bannerTitle: titleSearch,
      screenName: bannerScreenFilterValue?.label,
      statusName: statusSearch,
    };

    this.props.getBannerList(data);
  };

  render() {
    //  --------------------------dropdown options
    const bannerScreenListDropDownOptions = this.props?.bannerScreenList?.map(
      (item) => ({
        label: item?.label,
        value: item?._id,
      })
    );

    return (
      <BannerManagementView
        titleSearch={this.state.titleSearch}
        fields={this.state.fields}
        showMenuOptions={this.state.showMenuOptions}
        //
        bannersList={this.props.bannersList}
        //
        userPermissions={this.props.userPermissions}
        //dropdownOption
        bannerScreenListDropDownOptions={bannerScreenListDropDownOptions}
        //
        deleteBanner={this.props.deleteBanner}
        //
        handleShowMenuOptions={this.handleShowMenuOptions}
        handleCloseMenuOptions={this.handleCloseMenuOptions}
        //
        handleSaveDragAndDropRows={this.handleSaveDragAndDropRows}
        //
        onChangeSearchInput={this.onChangeSearchInput}
        onClickSearch={this.onClickSearch}
        onChangeBannerScreenOption={this.onChangeBannerScreenOption}
        //
        userRole={this.props.userRole}
        //table header filter
        onClickStatusDropDownFilterOptions={
          this.onClickStatusDropDownFilterOptions
        }
        //master states
        status={this.props.status}
        //unblock navigation
        unblock={this.unblock}
        //Modal controls
        showModal={this.state.showModal}
        showWarningPopup={this.showWarningPopup}
        showDeletePopup={this.showDeletePopup}
        handleCloseModal={this.onCloseModal}
        //
        handleSetRowReordered={this.props.setRowReordered}
        setRowReorderWarningModal={this.props.setRowReorderWarningModal}
        //
        redirectLink={this.props.redirectLink}
        resetBannerScreenFilter={this.props.resetBannerScreenFilter}
      />
    );
  }
}

BannerManagementContainer.propTypes = {};

const mapStateToProps = (state) => ({
  userPermissions: state.auth.userPermissions,
  //
  bannerScreenList: state.master.bannerScreenList,
  bannersList: state.bannerManagement.bannersList,
  rowReordered: state.bannerManagement.rowReordered,
  status: state.master.status,
  //
  titleSearch: state.bannerManagement.titleSearch,
  bannerScreenFilter: state.bannerManagement.bannerScreenFilter,
  //
  redirectLink: state.bannerManagement.redirectLink,
  //
  showRowReorderedModal: state.bannerManagement.showRowReorderedModal,
  //
  userRole: state.auth.userRole,
});

export default connect(mapStateToProps, {
  getBannerList,
  getBannerScreenList,
  getStatusList,
  deleteBanner,
  setRowReordered,
  setRowReorderWarningModal,
  setBannerScreenFilter,
  resetBannerScreenFilter,
})(BannerManagementContainer);
